import createTheme from '@mui/material/styles/createTheme';

const baseThemeOptions = {
    shape: {
        borderRadius: 16,
    },
    typography: {
        fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        h1: {
            fontWeight: 900,
            fontSize: '2.8rem',
            lineHeight: 1.15,
            letterSpacing: '-1.2px',
            '@media (min-width:900px)': {
                fontSize: '3.2rem',
            },
        },
        h2: {
            fontWeight: 800,
            letterSpacing: '-0.02em',
        },
        h3: {
            fontWeight: 700,
            letterSpacing: '-0.01em',
        },
        h4: {
            fontWeight: 700,
        },
        h5: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 600,
        },
        button: {
            fontWeight: 700,
            textTransform: 'none',
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    //backgroundColor: '#0f172a',
                    color: '#f8fafc',
                },
                h1: {
                    fontWeight: 900,
                    fontSize: '2.8rem',
                    lineHeight: 1.15,
                    letterSpacing: '-1.2px',
                },
                '@media (min-width:900px)': {
                    h1: {
                        fontSize: '3.2rem',
                    },
                },
                '::selection': {
                    backgroundColor: 'rgba(16, 185, 129, 0.35)',
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: ({ ownerState, theme }) => ownerState.component === 'h1' ? {
                    fontWeight: 900,
                    fontSize: '2.8rem',
                    lineHeight: 1.15,
                    letterSpacing: '-1.2px',
                    [theme.breakpoints.up('md')]: {
                        fontSize: '3.2rem',
                    },
                } : {},
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    paddingInline: '1.4rem',
                    paddingBlock: '0.6rem',
                    transition: 'all .2s ease',
                },
                sizeLarge: {
                    paddingInline: '1.8rem',
                    paddingBlock: '0.75rem',
                },
                containedPrimary: {
                    color: '#052e24',
                    '&:hover': {
                        backgroundColor: '#34d399',
                        transform: 'translateY(-1px)',
                    },
                },
                outlined: {
                    borderWidth: '1.5px',
                    '&:hover': {
                        borderWidth: '1.5px',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: 20,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                },
            },
        },
    },
};

export const darkTheme = createTheme({
    ...baseThemeOptions,
    palette: {
        mode: 'dark',
        primary: {
            main: '#10b981',
        },
        secondary: {
            main: '#b91048',
        },
        background: {
            default: '#0f172a',
            paper: '#1e293b',
        },
        text: {
            primary: '#f8fafc',
            secondary: '#9c9c9c',
        },
    },
});

export const lightTheme = createTheme({
    ...baseThemeOptions,
    palette: {
        mode: 'light',
        primary: {
            main: '#10b981',
        },
        secondary: {
            main: '#b91048',
        },
        background: {
            default: '#f8fafc',
            paper: '#ffffff',
        },
        text: {
            primary: '#0f172a',
            secondary: '#475569',
        },
    },
});
